import React from 'react'
import PropTypes from 'prop-types'

import { noop } from 'lodash'
import sanitizeHtml from 'sanitize-html'
import { ConversationInput } from '@scoir/messaging'

import api from 'common/api'

export default class ConversationInputWithApi extends React.Component {
  static propTypes = {
    participantIds: PropTypes.array.isRequired,
    onMessageSentSuccess: PropTypes.func,
    onMessageSentFailure: PropTypes.func,
  }
  static defaultProps = {
    onMessageSentSuccess: noop,
    onMessageSentFailure: noop,
  }
  state = {
    conversation: [],
  }
  addMessage(newMessage) {
    api
      .post('/api/discussions', {
        Participants: this.props.participantIds,
        Message: newMessage,
      })
      .then(() => {
        this.props.onMessageSentSuccess()
      })
      .catch(() => {
        this.props.onMessageSentFailure()
      })
  }
  render() {
    return (
      <ConversationInput
        onSendMessage={(newMessage) => this.addMessage(newMessage)}
        sanitizeFn={(text) => sanitizeHtml(text)}
        {...this.props}
      />
    )
  }
}
